// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The side navigation menu */
.sidenav {
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  bottom: 0;
  right: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 0; /* Place content 60px from the top */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
  z-index: 50;
  box-shadow: -2px -1px 7px -5px rgba(0, 0, 0, 0.75);
}

.sidenav .card {
  border: none;
}

.sidenav .card .card-header {
  height: 76px;
  padding-top: 20px;
  padding-bottom: 20px;
}

/* The navigation menu links */
.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

/* When you mouse over the navigation links, change their color */
.sidenav a:hover {
  color: #f1f1f1;
}

/* Position and style the close button (top right corner) */
.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

.sidenav .sidenav-container {
  height: calc(100% - 77px);
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-right 0.5s;
  padding: 20px;
}

#mySidenav {
  width: 470px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/right-sidenav/right-sidenav.component.scss"],"names":[],"mappings":"AAAA,6BAAA;AACA;EACE,QAAA,EAAA,0CAAA;EACA,eAAA,EAAA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,6CAAA;EACA,kBAAA,EAAA,8BAAA;EACA,cAAA,EAAA,oCAAA;EACA,gBAAA,EAAA,yDAAA;EACA,WAAA;EAGA,kDAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA,8BAAA;AACA;EACE,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA,iEAAA;AACA;EACE,cAAA;AACF;;AAEA,2DAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA,sHAAA;AACA;EACE,6BAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA,gIAAA;AACA;EACE;IACE,iBAAA;EACF;EACA;IACE,eAAA;EACF;AACF","sourcesContent":["/* The side navigation menu */\n.sidenav {\n  width: 0; /* 0 width - change this with JavaScript */\n  position: fixed; /* Stay in place */\n  bottom: 0;\n  right: 0;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n  overflow-x: hidden; /* Disable horizontal scroll */\n  padding-top: 0; /* Place content 60px from the top */\n  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */\n  z-index: 50;\n  -webkit-box-shadow: -2px -1px 7px -5px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: -2px -1px 7px -5px rgba(0, 0, 0, 0.75);\n  box-shadow: -2px -1px 7px -5px rgba(0, 0, 0, 0.75);\n}\n\n.sidenav .card {\n  border: none;\n}\n\n.sidenav .card .card-header {\n  height: 76px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n/* The navigation menu links */\n.sidenav a {\n  padding: 8px 8px 8px 32px;\n  text-decoration: none;\n  font-size: 25px;\n  color: #818181;\n  display: block;\n  transition: 0.3s;\n}\n\n/* When you mouse over the navigation links, change their color */\n.sidenav a:hover {\n  color: #f1f1f1;\n}\n\n/* Position and style the close button (top right corner) */\n.sidenav .closebtn {\n  position: absolute;\n  top: 0;\n  right: 25px;\n  font-size: 36px;\n  margin-left: 50px;\n}\n\n.sidenav .sidenav-container {\n  height: calc(100% - 77px);\n}\n\n/* Style page content - use this if you want to push the page content to the right when you open the side navigation */\n#main {\n  transition: margin-right 0.5s;\n  padding: 20px;\n}\n\n#mySidenav {\n  width: 470px;\n}\n\n/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */\n@media screen and (max-height: 450px) {\n  .sidenav {\n    padding-top: 15px;\n  }\n  .sidenav a {\n    font-size: 18px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
